import lodash from 'lodash'
import { colors } from './colors'
import { getItemsBuhtaByConfig } from '/src/utils/getItemsBuhtaByConfig'

export const captal = {
  id: 'captal',
  // tName: 'personalizations.captal.captal',
  template: 'modal',
  preview: 'cover',

  originPersonalizationsIds: [
    622, // Выбор каптала (дефолтный)
    623, // Выбор каптала
    721, // Выбор каптала Модерн
  ],

  getPersConfig,
  getItemsBuhta,
}

/** Формирует массив с выбранными персоналками и моделями
 * (нужно для отображения на 4-м шаге) */

function getPersConfig(store, oldModelValues) {
  const items = []
  const modelValues = {}

  const params = {
    store,
    oldModelValues,
    items,
    modelValues,
    originIdsAvailable: this.originIdsAvailable,
    originPersonalizations: this.originPersonalizations,
  }

  getColor(params)

  return {
    modelValues,
    items: lodash.sortBy(items, ['sort']),
  }
}

/** Формирует массив с выбранными персоналками бухты
 * (нужно для запроса цены) */
function getItemsBuhta({ modelValues }) {
  const originPersonalizations = this.originPersonalizations
  let idBuhta
  let idParam
  if (this.originPersonalizations[622]) {
    idBuhta = 622
    idParam = 91
  } else if (this.originPersonalizations[623]) {
    idBuhta = 623
    idParam = 92
  } else if (this.originPersonalizations[721]) {
    idBuhta = 721
    idParam = 91
  } else return []
  const idValue = modelValues?.color?.id

  return getItemsBuhtaByConfig(originPersonalizations, idBuhta, [
    {
      idParam,
      idValue,
    },
  ])
}

/**
 * Выбор цвета каптала
 */
function getColor(params) {
  const { oldModelValues, items, modelValues, originPersonalizations, store } = params

  let idBuhta
  let idParam
  if (originPersonalizations[622]) {
    idBuhta = 622
    idParam = 91
  } else if (originPersonalizations[623]) {
    idBuhta = 623
    idParam = 92
  } else if (originPersonalizations[721]) {
    idBuhta = 721
    idParam = 91
  } else return

  let values = []
  if (originPersonalizations[idBuhta].params) {
    const val = originPersonalizations[idBuhta].params.find((item) => item.id === idParam)
    if (val?.values?.length) {
      values = val.values.map((n) => ({
        ...n,
        background: colors[n.id] ?? n.hex,
      }))
    }
  }

  if (values.length > 0) {
    items.push({
      id: 'color',
      tName: 'personalizations.captal.color',
      template: 'selectClassicColor',
      sort: 10,
      values,
    })

    // Дефолтный каптал берётся в зависимости от цвета блока
    let defaultIndex
    if (store.blocksItemsKeys[store.selectedBlock?.id]?.paper > 1) {
      defaultIndex = values.findIndex((n) => n.id === 1296) // жёлтый
    } else {
      defaultIndex = values.findIndex((n) => n.id === 1295) // белый
    }
    if (defaultIndex < 0) {
      defaultIndex = 0
    }

    if (oldModelValues.color) {
      modelValues.color = values.find((i) => i.id === oldModelValues.color.id) ?? values[defaultIndex]
    } else {
      modelValues.color = values[defaultIndex]
    }
  }
}
